module.exports = __webpack_public_path__ + "img/simplified.1367422f.jpg";